<nav class="navbar navbar-expand-md position-relative justify-content-start bg-white px-3 shadow-sm">
    <a class="navbar-brand me-0 me-md-3 d-flex align-items-center px-md-1" routerLink="/" data-bs-toggle="tooltip" data-bs-placement="bottom"
    data-bs-html="true" title="<span> UI Version: {{uiVersion}}</span>">
        <i class="increff-client-icons increff-logo me-2 text-increff-orange"></i>
        <i class="increff-client-icons increff-text me-2 small text-dark"></i>
        <span class="text-dark">ACCOUNT</span>
    </a>
</nav>

<div class="col shadow-pill gradient-bar"></div>
<div class="container-fluid px-md-5 mb-3 h-100">
  <div class="row">
    <div class="col-12 col-md mb-3">
      <div class="card border-0 mb-0 h-100">
        <div class="card-body bg-light p-5">
            <h3 class="fw-light">Increff Account</h3>
            <p class="fw-light mb-0">
              Authentication server to authenticate users against any application.
            </p>
            <p class="text-muted small fw-light">Authentication made easy</p>
        </div>

      </div>
    </div>
    <div class="col-12 col-md mb-3">
      <div class="card mb-0 h-100 border-0">
        <div class="card-body shadow-sm p-5">
          <h2 class="fw-light">Sign In</h2>
          <com-form [formFields]="applicationFormFields" #applicationFormSpy (keyup.enter)="submitForm(applicationFormSpy?.formObjSpy);"></com-form>
          <button class="btn btn-sm btn-primary mt-n1" type="button" [disabled]="applicationFormSpy?.formObjSpy?.invalid" (click)="submitForm(applicationFormSpy?.formObjSpy)">Let's Start</button>
        </div>
      </div>
    </div>
  </div>
</div>

<footer class="bg-dark text-light position-sticky p-1" style="bottom:0;">
    <div class="container">
      <div class="row">
        <div class="col-12 text-center small">
          <a class="text-light text-underline-hover" [href]="getLoginRedirectionUrl()">Super Admin Login</a>
          <span> | </span>
          <a class="text-light text-underline-hover" href="https://static.increff.com/eula/nextscm-standard-eula.html" target="_blank" > Terms and Conditions </a>
          <span> | </span>
          <a class="text-light text-underline-hover" href="https://www.increff.com/privacy-policy/" target="_blank">Privacy Policy</a>
          <span> | </span>
          <a class="text-light text-underline-hover" href="https://www.increff.com/company/" target="_blank">About Us</a>
          <span> | </span>
          <a class="text-light text-underline-hover" href="https://www.increff.com/contact/" target="_blank">Contact Us</a>
          <br>
          <a class="text-light text-underline-hover" href="https://www.increff.com" target="_blank">www.increff.com</a>
          <span> | </span>
          <small class="text-light">&copy; NextSCM Solutions Pvt. Ltd. - All Right Reserved</small>
        </div>
      </div>
    </div>
  </footer>

  <ng-template #applicationHelperTextRef>
    <p class="small mb-0 mt-2 text-muted">Application you want to log into</p>
  </ng-template>